import React, { useEffect, useState } from 'react';
import { DialogContent } from "../../../../components/Dialog/DialogContent";
import { Typography } from "../../../../components/Typography/Typography";
import { pathToWorkTemplatePreview } from "../../../../helpers/route-helpers";
import { useTranslation } from "../../../../hooks/useTranslation";
import { DrillNavigation } from "../../../../others/DrillNavigation/DrillNavigation";
import { makeStyles } from "../../../../styles/index";
import { defaultTheme } from "../../../../styles/defaultTheme";
import { WorkTemplateGroup } from "./WorkTemplateGroup";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        padding: '0 !important',
        backgroundColor: theme.palette.background.default,
        overflowY: 'auto',
        flex: '1 1 auto',
        display: 'flex',
        flexDirection: 'row',
    },
    emptyMessage: {
        color: theme.palette.light.text.primary,
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    templateGroups: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        overflowY: 'auto',
        padding: theme.spacing(3, 0, 6, 0),
        backgroundColor: function (_a) {
            var subjectColor = _a.subjectColor;
            return subjectColor === null || subjectColor === void 0 ? void 0 : subjectColor.tertiary;
        },
    },
    templateGroup: {
        flexShrink: 0,
        margin: theme.spacing(0, 3),
        paddingBottom: theme.spacing(1),
        pointerEvents: 'auto',
    },
}); }, { name: 'SnTemplateContent' });
/**
 * テンプレート一覧
 */
export var TemplateContent = function (_a) {
    var workTemplateGroups = _a.workTemplateGroups, grade = _a.grade, subject = _a.subject, selectionGrades = _a.selectionGrades, selectionSubjects = _a.selectionSubjects, isLoading = _a.isLoading, hasError = _a.hasError, remainingCount = _a.remainingCount, onChangeGrade = _a.onChangeGrade, onChangeSubject = _a.onChangeSubject, onSelectTemplate = _a.onSelectTemplate, onUnselectTemplate = _a.onUnselectTemplate;
    var t = useTranslation().t;
    // 教科色
    var _b = useState(defaultTheme.palette.subjects.japanese), subjectColor = _b[0], setSubjectColor = _b[1];
    useEffect(function () {
        var _a;
        var color = ((_a = selectionSubjects.find(function (_a) {
            var id = _a.id;
            return id === subject;
        })) !== null && _a !== void 0 ? _a : {}).color;
        if (color != null) {
            setSubjectColor(color);
        }
    }, [selectionSubjects, subject]);
    var classes = useStyles({ subjectColor: subjectColor });
    // アイテム押下
    var handleClickWorkTemplate = function (courseId, workTemplateGroupId, workTemplateId) {
        window.open(pathToWorkTemplatePreview(courseId, workTemplateGroupId, workTemplateId), '_blank');
    };
    if (isLoading) {
        return React.createElement(DialogContent, { className: classes.root });
    }
    if (hasError) {
        return (React.createElement(DialogContent, { className: classes.root },
            React.createElement(Typography, { variant: "title" }, t('読み込みに失敗しました。'))));
    }
    return (React.createElement(DialogContent, { className: classes.root },
        React.createElement(DrillNavigation, { currentGrade: grade, currentSubject: subject, selectionGrades: selectionGrades, selectionSubjects: selectionSubjects, onChangeGrade: onChangeGrade, onChangeSubject: onChangeSubject }),
        React.createElement("div", { className: classes.templateGroups }, workTemplateGroups.length === 0 ? (React.createElement("div", { className: classes.emptyMessage },
            React.createElement(Typography, { variant: "title" }, t('テンプレートを準備中です。')))) : (workTemplateGroups.map(function (workTemplateGroup) {
            return (React.createElement("div", { key: workTemplateGroup.id, className: classes.templateGroup },
                React.createElement(WorkTemplateGroup, { model: workTemplateGroup, remainingCount: remainingCount, subjectColor: subjectColor, onSelectWorkTemplate: function (templateIds) {
                        return onSelectTemplate(templateIds, workTemplateGroup.id);
                    }, onUnselectWorkTemplate: onUnselectTemplate, onClickWorkTemplate: handleClickWorkTemplate })));
        })))));
};
